import { type FC } from 'react';

import { Box } from '../Box';
import { type FeatureListSection, FeatureList } from '../FeatureList';
import { Heading } from '../Typography';

export type InfoBoxProps = {
  /**
   * Heading text for the info box
   */
  heading: string;
  /**
   * Array of feature list sections to display
   */
  features: FeatureListSection[];
  /**
   * Additional CSS class names
   */
  className?: string;
};

const InfoBox: FC<InfoBoxProps> = ({ heading, features, className }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="var(--spacing-3)"
      className={className}
      color="var(--text-primary)"
    >
      <Heading size="2xs" fontWeight="bold">
        {heading}
      </Heading>

      <Box
        display="flex"
        flexDirection="column"
        gap="var(--spacing-5)"
        p="var(--spacing-4)"
        borderRadius="var(--radius-lg)"
        bg="var(--surface-neutral)"
        className={className}
      >
        {features.map((section, index) => (
          <FeatureList
            key={`${section.heading || 'section'}-${index}`}
            heading={section.heading}
            items={section.items}
          />
        ))}
      </Box>
    </Box>
  );
};

export default InfoBox;
